angular.module('AccountingBoxApp')
.directive('abfileviewer', function() {
	     //$scope.token = LoopBackAuth.accessTokenId;

  return {
    restrict: 'E',
    scope: {
      attachment: '=attachment'
    },
    templateUrl: 'app/components/fileViewer/fileViewer.html',
    controller: 'FileViewerCtrl'
  };
});
